import { render, staticRenderFns } from "./PolicyPopup.vue?vue&type=template&id=25f3b4b4&scoped=true&"
import script from "./PolicyPopup.vue?vue&type=script&lang=js&"
export * from "./PolicyPopup.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPopup.vue?vue&type=style&index=0&id=25f3b4b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3b4b4",
  null
  
)

export default component.exports